export { LocalesTypes, LocalesActions } from './locales.redux';

export * from './locales.selectors';
